// extracted by mini-css-extract-plugin
export default {"container":"NotificationCard_container__eNCPR","description":"NotificationCard_description__xF5dd","data":"NotificationCard_data__3vVzq","icon":"NotificationCard_icon__gagWP"};